/* eslint-disable complexity */
import React, { useState } from "react";
import { Select } from "antd";

import SingleSelectModal from "../SingleSelectModal";
import { getWindowWidth, isSearchMobile } from "../../../services";
import styles from "./style.scss";
import DisabledSelect from "./DisabledSelect";

interface IndexSelectProps {
  isDisabled?: boolean;
  onChange?: (value) => void;
  options?: { value: string; title: string }[];
  placeholder?: string;
  value?: string;
}

const FilterThreshold = 8;

const IndexSelect = (props: IndexSelectProps) => {
  const { options, value, onChange, placeholder } = props;

  const [showModal, setshowModal] = useState(false);

  const handleShowModal = () => {
    setshowModal(true);
  };

  const closeModal = () => {
    setshowModal(false);
  };

  const renderMobile = () => {
    const { options, isDisabled, value, onChange, placeholder } = props;
    const displayValue =
      value !== undefined
        ? (options.find(o => o.value === value) ? (options.find(o => o.value === value)).title : undefined)
        : undefined;

    return (
      <React.Fragment>
        <SingleSelectModal
          onCancel={closeModal}
          visible={showModal}
          options={options}
          value={value}
          onChange={onChange}
        />
        {isDisabled ? (
          <DisabledSelect
            options={options}
            value={value}
            placeholder={placeholder}
          />
        ) : (
          <div
              tabIndex={-1}
              role="button"
              onClick={handleShowModal}
              className={styles.value}
              style={{position: "relative"}}
            >
              <div style={{ position: "absolute", inset: 0, zIndex: 1 }}></div>
            <Select
              className={`${styles.value} ${
                value ? "dropdown-black-placeholder" : ""
              }`}
              disabled
              placeholder={placeholder}
              value={displayValue}
            ></Select>
          </div>
        )}
      </React.Fragment>
    );
  };

  if (isSearchMobile(getWindowWidth())) {
    return renderMobile();
  }

  return (
    <Select
      placeholder={placeholder}
      value={value || undefined}
      onChange={onChange}
      showSearch={options.length > FilterThreshold}
      optionFilterProp="children"
      notFoundContent={"Nema rezultata"}
    >
      {options.map(option => (
        <Select.Option key={option.value} value={option.value} style={option.style}>
          {option.title}
        </Select.Option>
      ))}
    </Select>
  );
};

IndexSelect.defaultProps = {
  placeholder: "Odaberite",
  onChange: () => null,
  isDisabled: false,
  value: null
};

export default IndexSelect;



// WEBPACK FOOTER //
// ./src/components/FormControls/IndexSelect/index.tsx